import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { baseStyles } from '@/styles';
import { iconExclamationTriangle } from '../icons';

@customElement('fg-message')
export class FgMessage extends LitElement {
  @property({ type: String })
  message = '';

  @property({ type: String })
  type = 'error';

  @property({ type: String })
  messageId = '';

  render() {
    return html`
      <div class="message ${this.type}" id="${this.messageId}">
        <span class="icon">${iconExclamationTriangle}</span>
        <span class="text">${this.message}</span>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    css`
      .message {
        margin-top: 10px;
        padding: 14px 18px;
        font-weight: 700;
        font-size: 1rem;
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .message.error {
        background-color: var(
          --fg-error-background,
          var(--fg-fallback-error-background)
        );
        color: var(--fg-error-content, var(--fg-fallback-error-content));
      }
      .message.error .icon svg {
        fill: var(--fg-error-content, var(--fg-fallback-error-content));
      }
      .icon {
        display: flex;
        align-items: center;
        height: 100%;
      }
      .icon svg {
        width: 16px;
        height: 16px;
      }
    `,
  ];
}
